import { render, staticRenderFns } from "./sex.vue?vue&type=template&id=72812959&scoped=true"
import script from "./sex.vue?vue&type=script&lang=js"
export * from "./sex.vue?vue&type=script&lang=js"
import style0 from "./sex.vue?vue&type=style&index=0&id=72812959&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72812959",
  null
  
)

export default component.exports